import NuxtRoutedPageSFC from "./NuxtRoutedPage.vue";
export const NuxtRoutedPage = NuxtRoutedPageSFC;
